import * as React from 'react';

import Loader from 'bundles/degree-home/components/Loader';
import SummaryCourseItem from 'bundles/degree-home/components/SummaryCourseItem';

import _t from 'i18n!nls/degree-home';

import { SummaryCard } from './SummaryCard';
import type {
  GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_inProgress_courseProgressState_DegreeLearnerCourseStatesV1_inProgressMember as CourseProgressState,
  GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_inProgress as InProgressCourse,
} from './v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';

type Props = {
  loading: boolean;
  inProgressCourses?: Array<InProgressCourse>;
};

export const InProgressCourses = ({ loading, inProgressCourses }: Props) => (
  <SummaryCard title={_t('In progress')} data-e2e="in-progress-courses" data-testid="in-progress-courses">
    {loading && <Loader />}
    {!loading &&
      inProgressCourses?.map((inProgressCourse: InProgressCourse) => {
        const progressState = inProgressCourse.courseProgressState as unknown as CourseProgressState;
        const isCourseEnrollable =
          progressState.inProgress.hasEnrollableSession && !progressState.inProgress.activeSessionId;

        return (
          <SummaryCourseItem
            key={inProgressCourse.id}
            courseId={inProgressCourse.id}
            courseName={inProgressCourse.name}
            courseSlug={inProgressCourse.slug}
            statusText={_t('In progress')}
            isCourseEnrollable={isCourseEnrollable}
          />
        );
      })}
  </SummaryCard>
);

export default InProgressCourses;
